
<div class="card" *ngIf="Data">
    
</div>